
 //indexDb 控制
 function indexDbControl(dbName,tableName,key){
    let request = indexedDB.open(dbName)
    let db = null
    function createControl(db,type,val){
        var tt = db.transaction([tableName],"readwrite");  
            var store =  tt.objectStore(tableName);  
            var request = store[type](val);
            return new Promise((resolve,reject)=>{
                request.onerror = function(e) {
                    reject(e)
                }
                request.onsuccess = function(e) {
                    resolve(e)
                }
        }) 
    }
    function  control(db){
        //增
        function add(data){
            return   createControl(db,'add',data)   
        }
        //删
        function del(key){
            return   createControl(db,'delete',key)      
        }
        //查
        function deal(key){
            return   createControl(db,'get',key).then((e)=> Promise.resolve(e.srcElement.result))     
        }
        //改
        function update(data){
            return   createControl(db,'put',data)     
        }
        //遍历
        function dealAll(){
            var tt = db.transaction([tableName],"readwrite");  
            var store =  tt.objectStore(tableName);  
            var request = store.openCursor()
            let result = []
            return new Promise((resolve,reject)=>{
                request.onerror = function(e) {
                    reject(e)
                }
                request.onsuccess = function(e) {
                    var cursor = e.target.result;
                    if (cursor) {
                        result.push(cursor)
                        cursor.continue();
                    } else {
                        resolve(result)
                    }
                }
            }) 
        }
        return {
            add,
            del, 
            deal,
            update, 
            dealAll,
        }
    }
    return new Promise((resolve,reject)=>{
        request.onerror = function(res){
            reject(res)
        }
        request.onsuccess = function (event){
            db = event.target.result;
            var trans = db.transaction([tableName],"readwrite");
            var store = trans.objectStore(tableName);
            resolve(control(db))
        }
        request.onupgradeneeded = function (event) {
            db = event.target.result;
            var storeNames = db.objectStoreNames;

            //创建数据库的表格（或者叫数据库仓库）
            if(!storeNames.contains(tableName)){
                db.createObjectStore(tableName,{
                    keyPath:key,
                })
            }
        }
    })

}
export default {
    install(Vue) {
        Vue.prototype.$indexdb = indexDbControl
    }
}



// WEBPACK FOOTER //
// ./src/plugins/indexdb/index.js